import { motion } from "framer-motion";

/**
 * Slow-moving, subtle gradient orbs used as premium background decoration.
 * Uses teal + blue palette to match branding, low opacity for calm feel.
 */
const AnimatedGradientOrbs = () => {
  return (
    <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none">
      <motion.div
        aria-hidden
        className="absolute rounded-full"
        style={{
          width: "620px",
          height: "620px",
          top: "-180px",
          left: "-120px",
          background:
            "radial-gradient(circle, rgba(20,184,166,0.20) 0%, rgba(20,184,166,0) 70%)",
          filter: "blur(40px)",
        }}
        animate={{ x: [0, 60, -20, 0], y: [0, 40, -30, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        aria-hidden
        className="absolute rounded-full"
        style={{
          width: "520px",
          height: "520px",
          top: "10%",
          right: "-160px",
          background:
            "radial-gradient(circle, rgba(37,99,235,0.22) 0%, rgba(37,99,235,0) 70%)",
          filter: "blur(50px)",
        }}
        animate={{ x: [0, -40, 30, 0], y: [0, 50, -20, 0] }}
        transition={{ duration: 28, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        aria-hidden
        className="absolute rounded-full"
        style={{
          width: "400px",
          height: "400px",
          bottom: "-140px",
          left: "35%",
          background:
            "radial-gradient(circle, rgba(14,165,233,0.14) 0%, rgba(14,165,233,0) 70%)",
          filter: "blur(50px)",
        }}
        animate={{ x: [0, -50, 40, 0], y: [0, -30, 20, 0] }}
        transition={{ duration: 26, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
};

export default AnimatedGradientOrbs;
